import React from 'react'

export default function europe() {
  return (
    <div>europe</div>
  )
}
